import React, { useEffect } from 'react';
import { useAuth } from '../../teal-react/utils/token';
import { useNavigate } from 'react-router';

const Authenticated = ({ children }: { children: any }) => {
  const { user, token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/auth');
    }
  }, [user, token]);

  if (!!user) {
    return <>{children}</>;
  }
  return null;
};

export default Authenticated;
